import React, { useContext, useState, useEffect } from "react";
import {
  ProSidebar,
  Menu,
  MenuItem,
  SubMenu,
  SidebarHeader,
  SidebarFooter,
  SidebarContent,
} from "react-pro-sidebar";
import { Link, useHistory } from "react-router-dom";
import { ContextProvider } from "../authorization/MyContext";

import Footer from "../Sidebar/components/Footer";
import Logout from "../../helpers/Logout";

import { SIDEBAR_MENU } from "./constants";
import { PermissionContext } from "../../context/PermissionContext";

import "react-pro-sidebar/dist/css/styles.css";
import "./style.css";
import {
  CanAccess,
  getUserAuthorizations,
  IsHaveMenu,
} from "../authorization/Authorization";
import { AxiosCustomGet } from "../../axios/AxiosCustom";
import Config from "../../axios/Config";
import Cookies from "js-cookie";
import { BsCircleFill } from "react-icons/bs";

const Sidebar = () => {
  const history = useHistory();
  const myPermissions = useContext(PermissionContext);
  const [userAuthorizations, setUserAuthorization] = useState({});
  const [bubbleNotification, setBubbleNotification] = useState({});

  const handleLogout = () => {
    Logout();
  };

  useEffect(() => {
    getBubbleNotification();
    getUserAuthorization();
  }, []);

  const getUserAuthorization = async () => {
    let user_authorizations = await getUserAuthorizations();
    setUserAuthorization(user_authorizations);
  };

  const getBubbleNotification = () => {
    const url = `${process.env.REACT_APP_BASE_API_URL}web/bubbles`;

    AxiosCustomGet(
      url,
      Config({
        Authorization: `Bearer ${Cookies.get("access_token")}`,
      }),
      (response) => {
        console.log(response.data.data);
        setBubbleNotification(response.data.data);
      }
    );
  };

  const getKey = (menus) => {
    let keys = [];
    menus.menus.map((menu) => {
      if (!menu.noKey) {
        keys.push(menu.key);
      }
    });
    return keys;
  };

  return (
    <ProSidebar className="text-white" width={260}>
      <ContextProvider
        value={{
          user_authorizations: userAuthorizations,
        }}
      >
        <SidebarHeader className="border-0 d-flex align-items-center justify-content-center py-3 font-weight-bold">
          <img
            src={`${process.env.REACT_APP_PUBLIC_URL}images/degadai-logo-inverse.png`}
            alt="logo"
            style={{ width: 150 }}
          />
        </SidebarHeader>
        <SidebarContent>
          {Object.keys(SIDEBAR_MENU).map((value) => {
            return (
              <>
                <CanAccess
                  role={getKey(SIDEBAR_MENU[value])}
                  yes={<div className="mx-2">{SIDEBAR_MENU[value].text}</div>}
                  no={<div style={{ marginTop: -20 }} />}
                />
                <Menu>
                  {SIDEBAR_MENU[value].menus.map((menu) => {
                    return Boolean(menu.subMenus.length) ? (
                      menu.key ? (
                        <CanAccess
                          role={menu.key}
                          yes={
                            <SubMenu title={menu.name} icon={menu.icon}>
                              {menu.subMenus.map((subMenu) =>
                                subMenu.key ? (
                                  <CanAccess
                                    role={subMenu.key}
                                    yes={
                                      <MenuItem
                                        suffix={
                                          subMenu.bubble &&
                                          bubbleNotification[subMenu.bubble] !==
                                            0 ? (
                                            <div className="numberCircle">
                                              {
                                                bubbleNotification[
                                                  subMenu.bubble
                                                ]
                                              }
                                            </div>
                                          ) : null
                                        }
                                        className="sub-menu"
                                        active={
                                          history.location.pathname ===
                                          subMenu.path
                                        }
                                      >
                                        {subMenu.name}
                                        <Link to={subMenu.path} />
                                      </MenuItem>
                                    }
                                  />
                                ) : (
                                  <MenuItem
                                    suffix={
                                      subMenu.bubble &&
                                      bubbleNotification[subMenu.bubble] !==
                                        0 ? (
                                        <div className="numberCircle">
                                          {bubbleNotification[subMenu.bubble]}
                                        </div>
                                      ) : null
                                    }
                                    className="sub-menu"
                                    active={
                                      history.location.pathname === subMenu.path
                                    }
                                  >
                                    {subMenu.name}
                                    <Link to={subMenu.path} />
                                  </MenuItem>
                                )
                              )}
                            </SubMenu>
                          }
                        />
                      ) : (
                        <SubMenu title={menu.name} icon={menu.icon}>
                          {menu.subMenus.map((subMenu) =>
                            subMenu.key ? (
                              <CanAccess
                                role={subMenu.key}
                                yes={
                                  <MenuItem
                                    suffix={
                                      menu.bubble &&
                                      bubbleNotification[menu.bubble] !== 0 ? (
                                        <div className="numberCircle">
                                          {bubbleNotification[menu.bubble]}
                                        </div>
                                      ) : null
                                    }
                                    className="sub-menu"
                                    active={
                                      history.location.pathname === subMenu.path
                                    }
                                  >
                                    {subMenu.name}
                                    <Link to={subMenu.path} />
                                  </MenuItem>
                                }
                              />
                            ) : (
                              <MenuItem
                                suffix={
                                  subMenu.bubble &&
                                  bubbleNotification[subMenu.bubble] !== 0 ? (
                                    <div className="numberCircle">
                                      {bubbleNotification[subMenu.bubble]}
                                    </div>
                                  ) : null
                                }
                                className="sub-menu"
                                active={
                                  history.location.pathname === subMenu.path
                                }
                              >
                                {subMenu.name}
                                <Link to={subMenu.path} />
                              </MenuItem>
                            )
                          )}
                        </SubMenu>
                      )
                    ) : menu.key ? (
                      <CanAccess
                        role={menu.key}
                        yes={
                          <MenuItem
                            suffix={
                              menu.bubble &&
                              bubbleNotification[menu.bubble] !== 0 ? (
                                <div className="numberCircle">
                                  {bubbleNotification[menu.bubble]}
                                </div>
                              ) : null
                            }
                            icon={menu.icon}
                            className="main-menu"
                            active={history.location.pathname === menu.path}
                          >
                            {menu.name}
                            <Link to={menu.path} />
                          </MenuItem>
                        }
                      />
                    ) : (
                      <MenuItem
                        suffix={
                          menu.bubble &&
                          bubbleNotification[menu.bubble] !== 0 ? (
                            <div className="numberCircle">
                              {bubbleNotification[menu.bubble]}
                            </div>
                          ) : null
                        }
                        icon={menu.icon}
                        className="main-menu"
                        active={history.location.pathname === menu.path}
                      >
                        {menu.name}
                        <Link to={menu.path} />
                      </MenuItem>
                    );
                  })}
                </Menu>
              </>
            );
          })}
        </SidebarContent>
        <SidebarFooter>
          <Footer handleLogout={handleLogout} />
        </SidebarFooter>
      </ContextProvider>
    </ProSidebar>
  );
};

export default Sidebar;
